<!--
 * @Description: 登录组件
 * @Author: hai-27
 * @Date: 2020-02-19 20:55:17
 * @LastEditors: hai-27
 * @LastEditTime: 2020-03-01 15:34:08
 -->
<template>
  <div id="add_float">
    <div class="edit_float_mid_bg">
      <div style="height: 100px"></div>
      <div class="edit_float_form_bg">
        <el-form
          :model="addManager"
          :rules="rules"
          status-icon
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <div style="height: 50px"></div>
          <div class="form_input_bg">
            <div class="input_left_bg1">原始密码</div>
            <el-form-item prop="pass" style="width: 550px; height: 60px">
              <el-input
                placeholder="请输入原始密码"
                v-model="addManager.pass"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form_input_bg">
            <div class="input_left_bg1">新密码</div>
            <el-form-item prop="newpass" style="width: 550px; height: 60px">
              <el-input
                placeholder="请输入新密码"
                v-model="addManager.newpass"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form_input_bg">
            <div class="input_left_bg1">确认新密码</div>
            <el-form-item prop="sureNewpass" style="width: 550px; height: 60px">
              <el-input
                placeholder="请确认新密码"
                v-model="addManager.sureNewpass"
              ></el-input>
            </el-form-item>
          </div>

          <div style="height: 10px"></div>
          <el-form-item style="display: flex; justify-content: center">
            <el-button
              size="medium"
              type="danger"
              @click="cancelPut"
              style="width: 100px"
              >取消</el-button
            >
            <el-button
              size="medium"
              type="primary"
              @click="commitPut"
              style="width: 100px"
              >修改</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: "changePassWord",
  props: {
    manageruser: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      buttonText: "",
      addManager: {
        pass: "",
        newpass: "",
        sureNewpass: "",
      },
      // 用户信息校验规则,validator(校验方法),trigger(触发方式),blur为在组件 Input 失去焦点时触发
      rules: {
        pass: [{ required: true, message: "原始不能为空", trigger: "blur" }],
        newpass: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
        ],
        sureNewpass: [
          { required: true, message: "确认新密码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    // 获取vuex中的showLogin，控制登录组件是否显示
  },
  //   mounted () {
  //     //   console.log('sss')
  //     if (this.manageruser.uid) {
  //       this.buttonText = '修改'
  //       let sendUser = {}
  //       //   console.log('sss')
  //       sendUser.name = this.manageruser.username ? (this.manageruser.username + '') : ''
  //       sendUser.pass = ''
  //       sendUser.nickname = this.manageruser.nickname ? (this.manageruser.nickname + '') : ''
  //       sendUser.email = this.manageruser.mail ? (this.manageruser.mail + '') : ''
  //       sendUser.phone = this.manageruser.phone ? (this.manageruser.phone + '') : ''
  //       console.log(JSON.stringify(sendUser))
  //       this.addManager = sendUser
  //     } else {
  //       this.buttonText = '提交'
  //     }
  //   },
  methods: {
    // ...mapActions(['setToken', 'setUser', 'setShowLogin']),
    // getUserInfo () {
    //   this.$axios
    //     .get('/api/userinfo')
    //     .then(res => {
    //       // “001”代表登录成功，其他的均为失败
    //       console.log(res)
    //       if (res.data.status === 200) {
    //         // this.setUser(res.data.data)
    //         store.dispatch('setUser', res.data.data)
    //       } else {
    //       }
    //     })
    //     .catch(err => {
    //       return Promise.reject(err)
    //     })
    // },
    cancelPut() {
      this.$emit("childFn");
    },
    commitPut() {
      let selfThis = this;
      let sendpass = this.addManager.pass;
      let sendnewpass = this.addManager.newpass;
      let sendsurenewpass = this.addManager.sureNewpass;
      //   if (sendpass=='') {
      //     alert('原始密码不能为空')
      //     return
      //   }
      //    if (sendnewpass=='') {
      //     alert('新密码不能为空')
      //     return
      //   }
      //    if (sendsurenewpass=='') {
      //     alert('确认新密码不能为空')
      //     return
      //   }
      if (
        this.addManager.pass.length>0 &&
        this.addManager.newpass.length>0 &&
        this.addManager.sureNewpass.length>0
      ) {
        this.$axios({
          url: "/yxUserBusiness/modifyPwd",
          method: "post",
          data: {
            oldPassword: sendpass,
            newPassword: sendnewpass,
            confirmNewPassword: sendsurenewpass,
          },
        })
          .then((res) => {
            // “001”代表登录成功，其他的均为失败
            console.log(res);
            // selfThis.$emit('childFn')
            if (res.data.success==false) {
              alert(res.data.msg);
            } else {
              selfThis.$emit("childFn");
              alert("密码修改成功");
              store.dispatch("LogOut").then(() => {});
            }
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      } else {
        alert("输入不能为空");
      }
    },
    checkEmail(email) {
      // var reg = /^([a-zA-Z]|[0-9])(\w|-) + @[a-zA-Z0-9] + \.([a-zA-Z]{2,4})$/
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (reg.test(email)) {
        // alert('邮箱格式正确');
        return true;
      } else {
        // alert('邮箱格式不正确');
        return false;
      }
    },
  },
};
</script>
<style>
  #add_float{
    position: fixed;
    z-index: 999;
    background-color: #00000033;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;

  }
  .edit_float_mid_bg{
    position: relative;
    width: 700px;
    height: 300px;
  }
  .edit_float_form_bg{
    width: 700px;
    height: 300px;
    background-color: white;
    border-radius: 20px;
  }
  .form_input_bg{
    width: 600px;
    height: 60px;
    padding: 0px 50px;
    /* background-color: red; */
    display: flex;
  }
  .input_left_bg1{
    width: 150px;
    height: 40px;
    line-height: 40px;
    /* background-color: red; */
    text-align: end;
    padding-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/changePassWord.vue